import Questions from '~/lib/Questions';
import { FC } from 'react';
import type {
  FormQuestion,
  FormAnswer as FormAnswerType,
} from '~/lib/Api.types';
import FormAnswer from './FormAnswer';
import { getCustomQuestion } from '~/lib/CustomQuestions/CustomQuestionRegistry';

/**
 * A custom question says for itself whether it has an answer worth listing,
 *  and what it is called when the business didn't label it. Read straight from
 *  the registry rather than through the hook, since this is a filter
 */
function customDefinitionFor(question: FormQuestion) {
    return question?.type === 'custom'
        ? getCustomQuestion(question?.settings?.customQuestionId)
        : null;
}

type FormAnswersProps = {
  answers: Array<{
    question: FormQuestion;
    answer: FormAnswerType;
    // Present for custom questions, worked out server side
    summary?: string;
  }>;
};
const FormAnswers: FC<FormAnswersProps> = ({ answers }) => {
  return (
    <div>
      {answers
        .filter(
          a =>
            !Questions[a.question.type]?.excludeFromAnswers &&
            !customDefinitionFor(a.question)?.flags?.excludeFromAnswers,
        )
        .map((answerData, idx) => (
          <div
            className={`my-2 ${idx > 0 ? 'mt-4' : ''}`}
            key={answerData.question.id}
          >
            <div className="label">
              {answerData.question.label ||
                customDefinitionFor(answerData.question)?.name ||
                Questions[answerData.question.type]?.name ||
                'No label'}
            </div>
            <div>
              <FormAnswer
                answer={answerData.answer.answer}
                question={answerData.question}
                summary={answerData.summary}
                answeredAt={answerData.answer?.created_at}
              />
            </div>
          </div>
        ))}
      {answers.length === 0 && <div>There are no answers to the form</div>}
    </div>
  );
};

export default FormAnswers;
